import React, { Component } from 'react'
import { connect } from 'react-redux';
import classnames from "classnames";

import { profileInvalidate, profileFetchIfNeeded } from './../store/profile/actions';
import Button from './shared/Button';
import OrderTabQA from './OrderTabQA';
import OrderTabQANew from './OrderTabQANew';
import baseStyles from 'custom/base.styl';

// import check from 'custom/img/check@3x.png';
import checkIcon from 'custom/checkIcon';

class PageCongratulations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    }

    this.showGradingData = this.showGradingData.bind(this);
  }

  componentDidMount() {
    const { load } = this.props;
    load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFetching !== this.props.isFetching) {
      this.setState({ gradeData: this.props.gradeData });
    }
  }

  showGradingData() {
    this.setState({ isOpen: true });
  }

  render() {
    const { gradeData, loading, status, stage, profile } = this.props;
    const { isOpen } = this.state;

    if (loading) {
      return null;
    }

    if (status === 'meeting' && stage === 'await_result') {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-header">
          <div className={baseStyles.header}>
            {checkIcon()}
            <h2 className={classnames(baseStyles.title_middle, baseStyles.text_success)}>Congratulations!</h2>
          </div>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}> <b>You've successfully joined our Livingston Research family!</b> </p>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}>
            We had to slow down the hiring process of new applicants, but we'll give you the access to the platform as soon as we have enough orders available to provide you with a steady monthly income. Stay tuned!
          </p>
        </div>
      )
    }

    // if (status === 'meeting' || status === 'new') {
    //   return (
    //     <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-header">
    //       <div className={baseStyles.header}>
    //         {checkIcon()}
    //         <h2 className={classnames(baseStyles.title_middle, baseStyles.text_success)}>Congratulations!</h2>
    //       </div>
    //       <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}> <b>You’ve completed all of the probation stages!</b> </p>
    //       <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}>
    //         Our Recruiting Managers will check your test task and get back to you with the results within 2-5 business days. Stay tuned!
    //       </p>
    //     </div>
    //   )
    // }

    if (status === 'hidden') {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered)} key="registration-success-header">
          <div className={baseStyles.header}>
            {checkIcon()}
            <h2 className={classnames(baseStyles.title_middle, baseStyles.text_success)}>Congratulations!</h2>
          </div>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}> <b>You’ve completed all of the probation stages!</b> </p>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}>
            Our Recruiting Managers will check your test task and get back to you with the results within 2-5 business days. Stay tuned!
          </p>
        </div>
      )
    }

    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.content_wide)}>
        <div className={baseStyles.header}>
          {checkIcon()}
          <h2 className={classnames(baseStyles.title_middle, baseStyles.text_success)}>You’ve made it!</h2>
        </div>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}><b>We are happy to inform you that you have successfully passed all tests <br />and become our freelancer!</b> </p>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.space_bottom)}>Please check your email with more details <br /> about the next steps. <br />We are looking forward to a fruitful cooperation!</p>

        {!isOpen && !!gradeData && (!!gradeData.pregrader_assessing_avg || !!gradeData.qa_report_score) &&
          <div className={baseStyles.mb_50}><a onClick={this.showGradingData}>[Check my Grading report] </a></div>
        }

        {isOpen && !!gradeData && !!gradeData.pregrader_assessing_avg &&
          <OrderTabQA order={gradeData} />
        }

        {isOpen && !!gradeData && !!gradeData.qa_report_score &&
          <OrderTabQANew order={gradeData} profile={profile} />
        }

        <Button onClick={() => window.location.href = 'http://myaccount.lrwriters.com/'}>Login to my account</Button>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const activeTasks = state.profile.data && state.profile.data.user && state.profile.data.user.active_tasks;
  const task = activeTasks && activeTasks.length && activeTasks[0];
  const gradeData = task && task.user_data && task.user_data.grade;
  const loading = !state.profile.data || state.profile.isFetching;
  const status = state.profile.data && state.profile.data.user && state.profile.data.user.status;
  const stage = state.profile.data && state.profile.data.user && state.profile.data.user.stage;
  const profile = (state.profile.data && state.profile.data.user && state.profile.data.user.profile) || null;

  return {
    loading,
    gradeData,
    status,
    stage,
    profile,
  };
};

const mapDispatchToProps = dispatch => ({
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageCongratulations);



// WEBPACK FOOTER //
// ./src/components/PageCongratulations.js